module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ve-8654417d0313322c0ee93b0de476124d.svg";